export default function skipToMainContent() {
  const main = document.getElementById("main-content") || document.querySelector("main");
  if (!main) return;

  // Main landmarks need a negative tab index to accept programmatic focus.
  if (!main.hasAttribute("tabindex")) main.setAttribute("tabindex", "-1");

  const header = document.querySelector("[data-site-header]");
  const position = header && window.getComputedStyle(header).position;
  const offset = position === "sticky" || position === "fixed"
    ? header.getBoundingClientRect().height
    : 0;

  main.style.scrollMarginTop = `${offset}px`;
  main.focus({ preventScroll: true });
  main.scrollIntoView({ behavior: "instant", block: "start" });
}
